/* eslint-disable max-len */
import React, {
  useEffect,
  useMemo,
  useRef,
} from 'react';
import Modal from '@mui/material/Modal';
import {
  Box, Button, Tab, Tabs,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import DataTable from '../../Common/DataTable';
import {
  selectedTabStyles, stylesTabIndicator, tabsStyles, tabStyles,
} from '../../Common/TabsStyles';
import { Cancel } from '../../media/images/Cancel';
import { RootState } from '../../redux/rootState';
import { Datatablestyle } from './utils/Constant';
import { MorningReportTableData } from './utils/TypeDashboard';
import { PrintIcon } from '../../assets/TableIcons';
import {
  clearIsReportRemoved, getMorningReport, getMorningReportPdf, removeMorningReport,
} from './redux/dashboardSlice';
import { setLoader } from '../../redux/loaderSlice';
import ScreenMorningReportPdf from './ScreenMorningReportPdf';
import ConfirmationModal from '../../Common/ConfirmationModal/ConfirmationModal';
import { ConfirmationIcon } from '../../assets/Icons/AnalystIcons/ConfirmationIcon';

interface IMorningReportModal {
  open: boolean;
  handleClose: () => void;
  handlePrinting: () => void;
}

export default function MorningReportModal({
  open, handleClose, handlePrinting,
}: IMorningReportModal) {
  const printRef = useRef(null);
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = React.useState(1);
  const [openConfirm, setOpenConfirm] = React.useState(false);
  const [jobIds, setJobIds] = React.useState<string[]>([]);
  const {
    morningReportData, morningReportPdfData, isMorningRepPdfLoading, isReportRemoved,
  } = useSelector((state:RootState) => state.dashboardReducer);

  const [receivedReports, overdueReports] = useMemo(() => {
    const overDue = morningReportData?.RecordsForDue?.map((item) => ({
      id: item?.JobOrder,
      jobOrder: item?.JobOrder,
      siteName: item?.Site,
      analyst: item?.Initials,
      receiveDate: item?.ReceiveDate,
      customerName: item?.Customer,
      dateSent: item?.DateSent,
      dueDate: item?.DueDate,
      isCompleted: item?.IsCompleted,
    }));
    const received = morningReportData?.RecordsForMorningReport?.map((item) => ({
      id: item?.JobOrder,
      jobOrder: item?.JobOrder,
      siteName: item?.Site,
      analyst: item?.Initials,
      receiveDate: item?.ReceiveDate,
      customerName: item?.Customer,
      dateSent: item?.DateSent,
      dueDate: item?.DueDate,
      isCompleted: item?.IsCompleted,
      isChecked: jobIds.includes(`${item?.JobOrder}`),
    }));
    return [received, overDue];
  }, [morningReportData, jobIds]);

  const handlePrint = useReactToPrint({
    content: () => printRef?.current,
    removeAfterPrint: true,
    copyStyles: true,
    onAfterPrint: () => {
      setOpenConfirm(true);
    },
    documentTitle: 'Morning Report',
  });

  useEffect(() => {
    if (isReportRemoved) {
      setJobIds([]);
      dispatch(clearIsReportRemoved());
      dispatch(getMorningReport());
    }
  }, [isReportRemoved]);

  useEffect(() => {
    dispatch(setLoader(isMorningRepPdfLoading));
  }, [isMorningRepPdfLoading]);

  useEffect(() => {
    if (Object.keys(morningReportPdfData).length > 0) {
      handlePrint();
    }
  }, [morningReportPdfData]);

  const receivedColumns = [
    { key: 'sn', label: 'selectall' },
    { key: 'jobOrder', label: 'Job Order #' },
    { key: 'customerName', label: 'Customer Name' },
    { key: 'siteName', label: 'Site Name' },
    { key: 'analyst', label: 'Analyst' },
    { key: 'receiveDate', label: 'Received Date' },
  ];
  const overDueColumns = [
    { key: 'jobOrder', label: 'Job Order #' },
    { key: 'customerName', label: 'Customer Name' },
    { key: 'siteName', label: 'Site Name' },
    { key: 'analyst', label: 'Analyst' },
    { key: 'dateSent', label: 'Date Sent' },
    { key: 'dueDate', label: 'Due Date' },
  ];

  const TABS = [
    { id: 1, label: 'Received Reports' },
    { id: 2, label: 'Overdue Reports' },
  ];

  const handleChangeTab = (tabId: number) => {
    setActiveTab(tabId);
  };

  const handleCheckBoxWithKey = (id: string) => {
    if (jobIds.includes(id)) {
      const filtered = jobIds.filter((ele) => ele !== id);
      setJobIds(filtered);
    } else {
      setJobIds([...jobIds, id]);
    }
  };

  const enabledBtn = useMemo(() => jobIds.length > 0, [jobIds]);
  const handleApiCall = () => {
    dispatch(getMorningReportPdf({ JobOrders: jobIds }));
  };
  const handleSelectAll = () => {
    if (receivedReports?.length > 0) {
      if (jobIds.length === receivedReports?.length) {
        setJobIds([]);
      } else {
        const allIds = receivedReports.map((item) => item.id);
        setJobIds(allIds);
      }
    }
  };

  const closeModal = () => {
    setJobIds([]);
    handleClose();
  };

  return (
    <>
      <Modal
        open={open}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={Datatablestyle}>
          <div className="customerInfo_container flex-row">
            <div className="customerInfo">
              Morning Report
            </div>
            <div className="cancel-icon" onClick={() => closeModal()}>
              <Cancel />
            </div>

          </div>
          <div className="customModalBtnContainer">
            <Tabs
              variant="scrollable"
              value={activeTab - 1}
              onChange={(_, newValue) => handleChangeTab(TABS[newValue].id)}
              style={tabsStyles}
              TabIndicatorProps={stylesTabIndicator}
            >
              {TABS.map((tab) => (
                <Tab
                  key={tab.id}
                  label={tab.label}
                  style={activeTab === tab.id ? selectedTabStyles : tabStyles}
                  className="tab_styles"
                />
              ))}
            </Tabs>
            <div style={{
              display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center',
            }}
            >
              <Button onClick={handleApiCall} style={{ cursor: enabledBtn ? 'pointer' : 'not-allowed' }} disabled={!enabledBtn} className={enabledBtn ? 'button_save_and_next' : 'button_cancel'}>Generate Report</Button>
              <div className="pointCursor" title="Print Report Log" onClick={handlePrinting}>
                <PrintIcon />
              </div>
            </div>
          </div>
          <DataTable<MorningReportTableData>
            data={(activeTab === 1 ? receivedReports : overdueReports) || []}
            columns={(activeTab === 1 ? receivedColumns : overDueColumns)}
            handleData={() => {}}
            totalRecords={10}
            checkBoxWithKey={['sn']}
            handleCheckBoxWithKey={handleCheckBoxWithKey}
            handleSelectAll={handleSelectAll}
            isAllSelected={jobIds.length === (receivedReports?.length || 0) && receivedReports?.length > 0}
          />
        </Box>
      </Modal>
      <ScreenMorningReportPdf printRef={printRef} />
      <ConfirmationModal
        show={openConfirm}
        setOpenFrom={() => setOpenConfirm(false)}
        handleConfirmation={() => {
          dispatch(removeMorningReport({ JobOrders: jobIds }));
          setOpenConfirm(false);
        }}
        text="Remove the previewed reports from the Received reports list?"
        confirmationIcon={<ConfirmationIcon />}
      />
    </>
  );
}
